import { RootState, SidebarTabs } from 'types'
import { Action } from 'redux/actions'
import { SidebarActions } from 'redux/actions/sidebar'

export default function reduce(
  state: RootState['sidebar'] = { locked: false, activeTab: SidebarTabs.Organizational },
  action: Action,
): RootState['sidebar'] {
  switch (action.type) {
    case SidebarActions.SET_SIDEBAR_LOCKED: {
      return Object.assign({}, state, {
        locked: action.payload.locked,
      })
    }

    case SidebarActions.SET_SIDEBAR_ACTIVE_TAB: {
      return Object.assign({}, state, { activeTab: action.payload.activeTab })
    }

    case SidebarActions.SET_INITIAL_SIDEBAR_STATE: {
      const { locked } = action.payload
      return Object.assign({}, state, { locked })
    }

    default:
      return state
  }
}
